module.exports = __webpack_public_path__ + "static/media/iar_vehicle_fire_hover.060b3d26.svg";